import { render } from "./log.vue?vue&type=template&id=f4c13728"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"

import "./log.vue?vue&type=style&index=0&id=f4c13728&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__